export default "__VITE_ASSET__B2M083et__"